export default __webpack_public_path__ + "static/media/Vector_avatar.e84df839.svg";